import * as ko from 'knockout';

/**
 * Set when a screen's initial load fails, so the loading indicator can say so
 * instead of spinning forever. The screen body stays hidden: its observables are
 * never populated, so rendering it would bind against empty or null data.
 */
export const loadFailed = ko.observable(false);

export class BaseLoadingScreen {
  loading = ko.observable(true);

  loadedAfter(promise: Promise<any>): Promise<any> {
    return promise.then(
      () => {
        this.loading(false);
      },
      (error) => {
        // Keep `loading` set so the screen body stays hidden, and tell the loading
        // indicator to show a failure message instead of spinning forever.
        loadFailed(true);
        return Promise.reject(error);
      }
    );
  }

  loaded() {
    this.loading(false);
  }
}
